import { gql } from '@apollo/client';
import { DOCUMENT_FIELDS } from '@/graphql/queries/documents';

export const GET_CARRIER_DOCUMENTS = gql`
    ${DOCUMENT_FIELDS}

    query GetCarrierDocuments($carrier_id: uuid!, $organization_id: uuid!) {
        documents(
            where: {
                _and: [
                    { client_id: { _eq: $carrier_id } }
                    { organization_id: { _eq: $organization_id } }
                    { type: { _in: ["AGREEMENT", "RATES", "NDA", "COI", "WORKERS_COMP", "W9", "MISC"] } }
                ]
            }
        ) {
            ...DocumentFields
            signed_on
            term_months
        }
    }
`;
